<template>
  <div class="container-fluid" id="app_top_menu" style="position: relative;">
    <div id="menu_top_part" class="row">
      <div class="col-xs-5" style="height: 100%;display: flex;flex-direction: row;align-items: center;">
        <a id="menu_logo" href="/" style="margin-left: 3.2vw;">
          <img src="../assets/shl_menu_logo.png">
        </a>
      </div>

      <div class="col-xs-7" id="menu_top_part_right">
<!--        <form onsubmit="return searchClose()" action="#" method="post" enctype="multipart/form-data">-->
        <search-input />
<!--          <input id="menu_search_input" type="text" name="menu_search_text" placeholder="输入关键字搜索" @keyup.enter="searchClose">-->
<!--        </form>-->

        <div style="position: relative;">
          <a id="menu_wechat_login"
             href="javascript:void(null);"
             class="btn dropdown-toggle"
             data-toggle="dropdown"
             style="text-align: center;display: flex;align-items: center;justify-content: center;">
            <img src="../assets/shl_menu_wechat.png" style="text-align: center;" >
          </a>
          <ul class="dropdown-menu" style="left: -55px;" role="menu" aria-labelledby="menu_wechat_login">
            <li role="presentation" style="padding: 0;left: 0;">
              <div style="width: 150px;text-align: center;margin-left: 3px;">
                <img src="../assets/shl_wechat_qrcode.jpg" style="width: 100%;height: auto;">
                <span >关注官方微信公众号</span>
              </div>
            </li>
          </ul>
        </div>


        <a href="mailto:shba@shslqxh.com" id="menu_mail_login">
          <img src="../assets/shl_menu_mail.png">
        </a>


        <a href="/personal/center" v-if="nickName != null" class="menu_margin_right_0_5">{{nickName}}</a>
        <a v-if="nickName != null" class="menu_margin_right_0_5" ><img src="../assets/shl_vertical_line.png" style="height: 1.3rem;width: auto;margin-top: -0.4rem;"></a>
        <a v-if="nickName != null" href="javascript:void (null);" @click="loginOut" class="menu_margin_right_3_2" style="min-width: 3rem">退出</a>


        <a v-if="nickName == null" href="/login" class="menu_margin_right_3_2" style="min-width: 3rem">登录</a>
      </div>
    </div>

    <div id="menu_bottom_part" class="row" style="position: relative;">
      <div class="col-xs-2 dropdown" v-for="(item, index) in tabList" style="position: static;"
           @mouseover="mainTabMouseOver(index)"
           @mouseout="mainTabMouseOut(index)"
           :key="'main_tab_' + index"
      >
        <a :href="item.src"
           :class="[index == currentIndex ? 'active' : '']"
           style="pointer-events: auto;font-weight: bold;"
        >{{item.title}}</a>

        <div class="menu_sub_bar_cur row" v-if="item.subList != undefined && item.subList != null && item.subList.length > 0">
          <ul
            class="dropdown-menu"
            :id="'dropmenu_sub_bar_' + index"
          >
            <li>
              <div class="menu_sub_bar_titles" >
                <a
                  v-for="(subItem, subIndex) in item.subList"
                  :class="[subItem.id == tabId ? 'active' : '']"
				  href="javascript:void(0)"
				  @click="subItemClicked(item.src, subItem.id)"
                  style="font-weight:bold;"
                >{{subItem.title}}</a>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalInstance from '../js/shba';
import SearchInput from "./search/SearchInput";
export default {
  name: "AppBigTopMenu",
  components: {
    SearchInput,
  },
  data() {
    return {
      hoverIndex: -1,
      showSubTabbar: false,
      subTabList: null,
      tempUserName: null,
      barTimer: null,
      currentBar: null,
    }
  },
  mounted() {
    let _this = this;
    this.checkToken(this.$store, function (data) {
      let code = data.code;
      if (code != 0) {
        _this.tempUserName = null;
      }
    })


    this.eventManager.register('app-big-top-menu', this.eventManager.notificationNameObject.UserUpdate, function () {
      let user = _this.$store.state.dataStore.getUser();
      _this.tempUserName =  user == null ? null : user.nickName;
    });

  },
  destroyed() {
    this.eventManager.unregister('app-big-top-menu', this.eventManager.notificationNameObject.UserUpdate);
    this.clearBarTimer();
  },

  computed: {
    eventManager() {
      return this.$store.state.eventManager;
    },
    dataManager() {
      return this.$store.state.dataStore;
    },
    tabId() {
      return GlobalInstance.methods.currentSubTabId(this.$route);
    },
    nickName() {
      if (this.tempUserName == null) {
        let user = this.dataManager.getUser();
        if (user != null) {
          this.tempUserName = user.nickName;
        }
      }
      return this.tempUserName;
    },

    params() {
      return this.$route.params;
    },
    path() {
      return this.$route.path;
    },

    currentIndex() {
      let index = GlobalInstance.methods.currentMenuIndex(this.$route);
      return index;
    },
    tabList() {
      return this.$store.state.tabList
    },
  },
  methods: {
	subItemClicked(src, id) {
		let path = src + '/' + id;
		if (src == '/training' && id == '0504') {
	    let user = this.$store.state.dataStore.getUser();
	    if (user != null && user.isTeam == 1) { // 团体用户
	      this.$router.push(src);
	    } else {
			if (user == null) {
				this.$router.push("/login");
			} else {
				this.$router.push({
					name: 'personalPage'
				});
			}
	    }
		} else {
			this.$router.push(path);
		}
	},
    mainTabMouseOver(index) {
      this.subBarMouseOver(index);

    },
    mainTabMouseOut(index) {
      this.subBarMouseOut(index);
    },

    clearBarTimer() {
      if (this.barTimer != null) {
        clearTimeout(this.barTimer);
        this.barTimer = null;
      }
    },

    setBarTimer() {
      let _this = this;
      this.barTimer = setTimeout(function () {
        _this.barTimer = null;
        $('#' + _this.currentBar).hide();
        _this.currentBar = null;
      }, 5000);
    },

    resetBarTimer() {
      this.clearBarTimer();
      this.setBarTimer();
    },

    subBarMouseOver(index) {
      let id = 'dropmenu_sub_bar_' + index;
      if (this.currentBar != null) {
        if (this.currentBar == id) {
          this.clearBarTimer();
          this.currentBar = null;
          return
        } else {
          $('#' + this.currentBar).hide();
          this.clearBarTimer();
          this.currentBar = null;
        }
      }
      let bar = $('#' + id);
      if (bar != null) {
        bar.show();
      }
    },
    subBarMouseOut(index) {
      let id = 'dropmenu_sub_bar_' + index;
      let bar = $('#' + id);
      if (bar != null) {
        this.currentBar = id;
        bar.show();
        this.setBarTimer();
      }
    },
    searchClose() {
      let input = $("input[name='menu_search_text']");
      let searchText = input.val();
      input.val('');
      GlobalInstance.search.searchClose(this.$router, searchText);
    },
    loginOut() {
      let _this = this;
      this.$store.state.http.ajax.userSignOut(function (data) {
        _this.tempUserName = null;
      }, function (data) {
        _this.tempUserName = null;
      });
    },
  }
}
</script>

<style scoped>
  #app_top_menu {
    background: #e71a34 url("../assets/shl_top_menu_bg.png") no-repeat 40% top;
    /*background-image: url("./assets/shl_top_menu_bg.png");*/
    background-size: auto 100%;
    max-height: 202px;
    height: 14.8858vw;
    position: relative;
  }

  #menu_top_part {
    height: 9.7273vw;
    padding: 0;
    max-height: 132px;
  }
  #menu_bottom_part {
    height: 5.1585vw;
    max-height: 70px;
    padding: 0;
    margin-bottom: 0;
    background-color: transparent;
    border-top: none;
    box-shadow: 0 0 8px rgba(0.05,0.05,0.05, 0.2) inset;
  }


  #menu_top_part > div {
    height: inherit;
    max-height: inherit;
  }
  #menu_top_part_right {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  #menu_logo > img {
    height: 7.51vw;
    max-height: 90px;
    width: auto;
  }

  #menu_top_part_right a{
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: none;
  }

  .menu_margin_right_3_2 {
    margin-right: 2.8vw;
  }
  .menu_margin_right_0_5 {
    margin-right: 0.5vw;
  }


  #menu_mail_login, #menu_wechat_login {
    background-image: url("../assets/shl_menu_mail_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 0 0;
    width: 50px;
    height: 50px;
    margin-top: 4px;

  }

  #menu_mail_login {
    margin-right: 4vw;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  #menu_mail_login img {
    /*width: 1.9160vw;*/
    width: 26px;
    height: auto;
    margin-top: -9px;
  }

  #menu_wechat_login {
    margin-right: 0.5vw;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  #menu_wechat_login img {
    height: 24px;
    margin-top: -10px;
    width: auto;
  }

  #menu_search_input {
    outline: none;
    background-color: rgba(255,255,255, 0.3);
    background-image: url("../assets/shl_menu_search.png");
    background-repeat: no-repeat;
    background-position-y: center;
    background-size: 21px 21px;
    background-position-x: 84%;
    text-indent: 2rem;
    /*width: 20rem;*/
    margin-right: 2vw;
    height: 48px;
    border-radius: 24px;
    border: none;
    font-size: 1rem;
    color: white;
    max-width: 340px;
    width: 25.0553vw;
    letter-spacing: 3px;
  }
  #menu_search_input::-webkit-input-placeholder {
    color: white;
  }

  #menu_bottom_part {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 4vw;
    padding-right: 4vw;
  }
  #menu_bottom_part > div {
    padding-left: 2px;
    padding-right: 2px;
  }
  #menu_bottom_part  a {
    color: white;
    text-decoration: none;
    max-height: inherit;
    text-align: center;
    min-width: 100px;
  }
  #menu_bottom_part > div > a {
    display: inline-block;
    height: 4.5vw;
    line-height: 4.5vw;
    text-align: center;
    width: 100%;
    vertical-align: middle;
  }
  #menu_bottom_part  a:hover, #menu_bottom_part  a.active {
    color: black;
  }

  #menu_bottom_part  a.active {
    pointer-events: none;
  }

  .menu_sub_bar_cur {
    position: absolute;
    left: 2px;
    bottom: 2px;
    background-color:blue;
    padding: 0;
  }

  .menu_sub_bar_cur > ul {
    background-color:rgba(0,0,0,0.5);
    padding: 0;
    margin: 0;
    margin-left: 10px;
  }

  .menu_sub_bar_cur > ul > li {
    width: 100vw;
    height: 40px;
  }

  .menu_sub_bar_titles {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .menu_sub_bar_titles > a {
    display: inline-block;
    padding: 10px 15px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppBigTopMenu.vue